import {
    CREATE_CREDENTIAL_GLOBAL,
    GET_CREDENTIAL_GLOBAL,
    EDIT_CREDENTIAL_BY_ID_GLOBAL,
    CREATE_SERVICE_GLOBAL,
    GET_SERVICES,
    EDIT_SERVICE_BY_ID_GLOBAL,
    DELETE_SERVICE_BY_ID_GLOBAL,
    DELETE_CREDENTIAL_BY_ID_GLOBAL,
    GET_DEPARTMENTS,
    CREATE_DEPARTMENT_GLOBAL,
    EDIT_DEPARTMENT_BY_ID_GLOBAL,
    DELETE_DEPARTMENT_BY_ID_GLOBAL,
    CREATE_JOB_GLOBAL,
    GET_JOBS,
    EDIT_JOB_BY_ID_GLOBAL,
    DELETE_JOB_BY_ID_GLOBAL,
    CREATE_PLACE_GLOBAL,
    GET_PLACES,
    EDIT_PLACE_BY_ID_GLOBAL,
    DELETE_PLACE_BY_ID_GLOBAL,
    CREATE_COVERED_CREDENTIAL,
    EDIT_COVERED_CREDENTIAL,
    SELECTED_CREDENTIAL,
    REMOVE_SELECTED_CREDENTIAL,
    CREATE_COMPANY,
    GET_COMPANY,
    EDIT_COMPANY,
    DELETE_COMPANY,
    GET_CONNECT_CALENDARS,
    DISCONNECT_CALENDAR,
    CHANGE_CALENDAR_STATUS,
    STRIPE_SETTINGS,
    CREATE_BANK,
    GET_BANKS,
    EDIT_BANK,
    DELETE_BANK,
    CHANGE_AI_INTEGRATION,
    GET_SYSTEM_INTEGRATIONS,
    CONNECT_INTEGRATION,
    DISCONNECT_INTEGRATION,
    EDIT_INTEGRATION_CONNECTION,
    CAN_USE_INTEGRATION,
    DELETE_INTEGRATION,
    CONNECT_ZOOM,
    EDIT_ZOOM_STATUS,
    CONNECTION_ZOOM_TO_THERAPY,
    CREATE_ZOOM_MEETING,
    DELETE_ZOOM_MEETING,
    GET_ZOOM_USERS,
    GET_COMPANIES,
    CONNECT_GOOGLE_MEET,
    CONNECTION_GOOGLE_MEET_TO_THERAPY,
    EDIT_GOOGLE_MEET_STATUS,
    GET_TELEHEALTH_STATUS,
    GET_SUPERVISION_CONFIG,
    UPDATE_SUPERVISION_CONFIG,
    UPDATE_CLINICAL_SETTINGS,
    GET_ELIGIBILITY_AUTO_CHECK_CONFIG,
    UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG,
    RUN_BATCH_ELIGIBILITY_CHECK,
    GET_MEMBERS_PORTAL_CONFIG,
    UPDATE_MEMBERS_PORTAL_CONFIG,
} from './system.type';

/** Service Type */

export const createServiceGlobal = (body) => {
    return {
        type: CREATE_SERVICE_GLOBAL,
        payload: { body },
    };
};

export const getServices = (data, load) => {
    return {
        type: GET_SERVICES,
        payload: { data, load },
    };
};

export const editServiceByIdGlobal = (body, id) => {
    return {
        type: EDIT_SERVICE_BY_ID_GLOBAL,
        payload: { body, id },
    };
};

export const deleteServiceByIdGlobal = (id) => {
    return {
        type: DELETE_SERVICE_BY_ID_GLOBAL,
        payload: { id },
    };
};

/** End */

/** Credentials */

export const createCredentialGlobal = (body) => {
    return {
        type: CREATE_CREDENTIAL_GLOBAL,
        payload: { body },
    };
};

export const createCoveredCredential = (id, body) => {
    return {
        type: CREATE_COVERED_CREDENTIAL,
        payload: { id, body },
    };
};

export const getCredentialGlobal = () => {
    return {
        type: GET_CREDENTIAL_GLOBAL,
    };
};

export const editCredentialByIdGlobal = (body, id) => {
    return {
        type: EDIT_CREDENTIAL_BY_ID_GLOBAL,
        payload: { body, id },
    };
};

export const editCoveredCredential = (credentialId, id, body) => {
    return {
        type: EDIT_COVERED_CREDENTIAL,
        payload: { credentialId, id, body },
    };
};

export const deleteCredentialByIdGlobal = (id) => {
    return {
        type: DELETE_CREDENTIAL_BY_ID_GLOBAL,
        payload: { id },
    };
};

export const selectCredential = (item) => {
    return {
        type: SELECTED_CREDENTIAL,
        payload: item,
    };
};

export const removeCredential = (item) => {
    return {
        type: REMOVE_SELECTED_CREDENTIAL,
        payload: { item },
    };
};
/** End */

/** Departments */

export const createDepartmentGlobal = (body) => {
    return {
        type: CREATE_DEPARTMENT_GLOBAL,
        payload: { body },
    };
};

export const getDepartments = () => {
    return {
        type: GET_DEPARTMENTS,
    };
};

export const editDepartmentByIdGlobal = (body, id) => {
    return {
        type: EDIT_DEPARTMENT_BY_ID_GLOBAL,
        payload: { body, id },
    };
};

export const deleteDepartmentByIdGlobal = (id) => {
    return {
        type: DELETE_DEPARTMENT_BY_ID_GLOBAL,
        payload: { id },
    };
};

/** End */

/** Job */

export const createJobGlobal = (body) => {
    return {
        type: CREATE_JOB_GLOBAL,
        payload: { body },
    };
};

export const getJobs = () => {
    return {
        type: GET_JOBS,
    };
};

export const editJobByIdGlobal = (body, id) => {
    return {
        type: EDIT_JOB_BY_ID_GLOBAL,
        payload: { body, id },
    };
};

export const deleteJobByIdGlobal = (id) => {
    return {
        type: DELETE_JOB_BY_ID_GLOBAL,
        payload: { id },
    };
};

/** End */

/** Place */

export const createPlaceGlobal = (body) => {
    return {
        type: CREATE_PLACE_GLOBAL,
        payload: { body },
    };
};

export const getPlaces = () => {
    return {
        type: GET_PLACES,
    };
};

export const editPlaceByIdGlobal = (body, id) => {
    return {
        type: EDIT_PLACE_BY_ID_GLOBAL,
        payload: { body, id },
    };
};

export const deletePlaceByIdGlobal = (id) => {
    return {
        type: DELETE_PLACE_BY_ID_GLOBAL,
        payload: { id },
    };
};

/** End */

/** Company */
export const createCompany = (params) => {
    return {
        type: CREATE_COMPANY,
        payload: { params },
    };
};

export const getCompany = (load) => {
    return {
        type: GET_COMPANY,
        payload: { load },
    };
};

/**
 * `mergeLatest`: `params` holds only the fields to change. The saga re-reads the office first and
 * sends it whole with them, because the office PATCH rewrites every field from the body — a screen
 * holding an older copy of the office (e.g. System Preferences) would otherwise undo edits made elsewhere.
 */
export const editCompany = (id, params, { mergeLatest = false } = {}) => {
    return {
        type: EDIT_COMPANY,
        payload: { id, params, mergeLatest },
    };
};

export const deleteCompany = (id) => {
    return {
        type: DELETE_COMPANY,
        payload: { id },
    };
};

export const getCompanies = (load) => {
    return {
        type: GET_COMPANIES,
        payload: { load },
    };
};

/** End */

/** Calendars */

export const getConnectCalendars = (id) => {
    return {
        type: GET_CONNECT_CALENDARS,
        payload: { id },
    };
};

export const disconnectCalendar = (params) => {
    return {
        type: DISCONNECT_CALENDAR,
        payload: params,
    };
};

export const calendarStatus = (params) => {
    return {
        type: CHANGE_CALENDAR_STATUS,
        payload: params,
    };
};

/** End */

/** Stripe */

export const stripeSettings = (params) => {
    return {
        type: STRIPE_SETTINGS,
        payload: params,
    };
};

/** End */

/** Bank */

export const createBank = (body) => {
    return {
        type: CREATE_BANK,
        payload: { body },
    };
};

export const getBanks = (data, load) => {
    return {
        type: GET_BANKS,
        payload: { data, load },
    };
};

export const editBank = (id, body) => {
    return {
        type: EDIT_BANK,
        payload: { id, body },
    };
};

export const deleteBanks = (id) => {
    return {
        type: DELETE_BANK,
        payload: { id },
    };
};

/** End */

/** Ai Integration */

export const changeAiIntegration = (params) => {
    return {
        type: CHANGE_AI_INTEGRATION,
        payload: params,
    };
};

/** End */

/** Integrations */
export const getIntegrations = () => {
    return {
        type: GET_SYSTEM_INTEGRATIONS,
    };
};

export const connectIntegration = (params) => {
    return {
        type: CONNECT_INTEGRATION,
        payload: params,
    };
};

export const disconnectIntegration = (isActive, type) => {
    return {
        type: DISCONNECT_INTEGRATION,
        payload: { isActive, type },
    };
};

export const editIntegration = (params) => {
    return {
        type: EDIT_INTEGRATION_CONNECTION,
        payload: params,
    };
};

export const canUseIntegration = () => {
    return {
        type: CAN_USE_INTEGRATION,
    };
};

export const deleteIntegration = () => {
    return {
        type: DELETE_INTEGRATION,
    };
};

/** End */

/** Zoom */

export const connectZoom = () => {
    return {
        type: CONNECT_ZOOM,
    };
};

export const connectZoomToTherapy = (body) => {
    return {
        type: CONNECTION_ZOOM_TO_THERAPY,
        payload: body,
    };
};
export const editZoomStatus = () => {
    return {
        type: EDIT_ZOOM_STATUS,
    };
};

export const createZoomMeeting = (body, appt) => {
    return {
        type: CREATE_ZOOM_MEETING,
        payload: { body, appt },
    };
};
export const deleteZoomMeeting = (apptId, appt) => {
    return {
        type: DELETE_ZOOM_MEETING,
        payload: { apptId, appt },
    };
};
export const getZoomUsers = () => {
    return {
        type: GET_ZOOM_USERS,
    };
};

/** End */


/** Telehealth */
export const getTelehealthStatus = () => {
    return {
        type: GET_TELEHEALTH_STATUS,
    };
};
/** End */

/** Google Meet */

export const connectGoogleMeet = () => {
    return {
        type: CONNECT_GOOGLE_MEET,
    };
};

export const connectGoogleMeetToTherapy = (body) => {
    return {
        type: CONNECTION_GOOGLE_MEET_TO_THERAPY,
        payload: body,
    };
};

export const editGoogleMeetStatus = () => {
    return {
        type: EDIT_GOOGLE_MEET_STATUS,
    };
};

/** End */

/** Supervision Config */

export const getSupervisionConfig = () => {
    return {
        type: GET_SUPERVISION_CONFIG,
    };
};

export const updateSupervisionConfig = (params) => {
    return {
        type: UPDATE_SUPERVISION_CONFIG,
        payload: params,
    };
};

/** End */

/** Clinical Settings */

export const updateClinicalSettings = (params) => {
    return {
        type: UPDATE_CLINICAL_SETTINGS,
        payload: params,
    };
};

/** End */

/** Eligibility Auto-Check Config */

export const getEligibilityAutoCheckConfig = () => {
    return {
        type: GET_ELIGIBILITY_AUTO_CHECK_CONFIG,
    };
};

export const updateEligibilityAutoCheckConfig = (params) => {
    return {
        type: UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG,
        payload: params,
    };
};

export const runBatchEligibilityCheck = () => {
    return {
        type: RUN_BATCH_ELIGIBILITY_CHECK,
    };
};

/** End */

/** Members Portal Config */

export const getMembersPortalConfig = () => {
    return {
        type: GET_MEMBERS_PORTAL_CONFIG,
    };
};

export const updateMembersPortalConfig = (params) => {
    return {
        type: UPDATE_MEMBERS_PORTAL_CONFIG,
        payload: params,
    };
};

/** End */
